import { cn } from "@/lib/utils";

/**
 * True until the given ISO date (YYYY-MM-DD, Sydney time), so a "New" marker
 * drops off by itself once a feature has been out for a while.
 */
export function isStillNew(until, now = new Date()) {
  if (!until) return false;
  const today = now.toLocaleDateString("en-CA", {
    timeZone: "Australia/Sydney",
  });
  return today < until;
}

const BADGE_STYLES = {
  // Inline pill, e.g. at the end of a full-width menu row
  pill: "inline-flex items-center rounded-md border border-pink-200 bg-[#FFE6F6] px-1.5 text-[11px] font-semibold leading-[18px] text-[#C8007E]",
  // Small tag pinned to the top-right of a word; the parent needs `relative`.
  // Takes no layout space, so the nav doesn't shift.
  corner:
    "pointer-events-none absolute -top-3 right-0 translate-x-1/2 rounded-full bg-emerald-700 px-1 text-[9px] font-bold uppercase leading-[13px] tracking-wide text-white ring-2 ring-white",
};

/** "New" marker for a recently launched link or feature. */
export function NewBadge({ variant = "pill", className }) {
  return <span className={cn(BADGE_STYLES[variant], className)}>New</span>;
}

/** Pink dot for an icon button (e.g. the menu) that hides something new. */
export function NewDot({ className }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute right-1 top-1 h-2 w-2 rounded-full bg-brand-pink shadow-[0_0_0_2px_#fff]",
        className,
      )}
    />
  );
}
